export default class MessageTemplateService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('me/messages', params)
	}

	getRecipients(messageId, params) {
		return this.apiService.callGet('me/message/'+ messageId +'/recipients', params)
	}

	getDefaultValues(params){
		return this.apiService.callGet('me/message/default_values', params);
	}

	createEntity(params) {
		return this.apiService.callPost('me/message', params)
	}

	getNewMessageRecipients(params) {
		return this.apiService.callPost('me/message_recipients', params)
	}

	messageRecipientsCount(params) {
		return this.apiService.callPost('me/message_recipients_count', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/message/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/message/' + id, params)
	}

	deleteRecipient(id) {
		return this.apiService.callDelete('me/message/recipient/' + id);
	}
}



// WEBPACK FOOTER //
// ./src/service/MessageService.js